import appConfigs from "@configs/app";
import httpClient from "@plugins/http";
import type { ApiResponse } from "@apis/api";
import { cookieManager } from "@utils/cookie.manager.ts";

interface DictionaryTermMedia {
  audio: string | null;
  image: string | null;
}

interface DictionaryTermDefinition {
  definition: string;
  example: string;
}

interface DictionaryTermResult {
  pinyin: string | null;
  definitions: Record<string, DictionaryTermDefinition[]>;
  media: DictionaryTermMedia;
}

interface DictionarySearchData {
  matched: string;
  translations: string[];
  result: DictionaryTermResult[];
}

interface DictionarySearchParams {
  term: string;
  translations: string[];
  language: string;
}

export type {
  DictionarySearchParams,
  DictionarySearchData,
  DictionaryTermResult,
  DictionaryTermDefinition,
  DictionaryTermMedia,
};

export const search = (
  params: DictionarySearchParams,
): Promise<ApiResponse<DictionarySearchData>> => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return httpClient.get("/search", {
    baseURL: appConfigs.dictionaryApiBaseUrl,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      term: params.term,
      translations: params.translations,
      language: params.language,
    },
  });
};
